module.exports = __webpack_public_path__ + "static/media/guide.672efa6a.pdf";